var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":_vm.color,"disabled":_vm.disabled},on:{"click":function () {
      _vm.$emit('click');
    }}},[_c('v-icon',[_vm._v(_vm._s(_vm.leftSideIcon))]),_c('span',[_vm._v(_vm._s(_vm.title))]),_c('v-icon',[_vm._v(_vm._s(_vm.rightSideIcon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }